import styled, { css } from 'styled-components';

const avatarWithImage = css<{ pictureUrl?: string }>`
  background-image: ${(props) => `url(${props.pictureUrl})`};
  background-size: cover;
  background-position: center;
  color: transparent;
`;

const customSize = css<{ size?: number }>`
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
`;

export const Box = styled.div<{ size?: number; pictureUrl?: string }>`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  background: linear-gradient(139.04deg, #6a92e9 15.28%, #84a5ed 44.81%, #a8bff2 84.37%);
  color: #fff;
  text-transform: uppercase;
  font-size: ${(props) => (props.pictureUrl ? 0 : '11px')};
  font-weight: 600;
  ${({ pictureUrl }) => pictureUrl && avatarWithImage};
  ${({ size }) => size && customSize};
`;
